// NOTA: manca solamente il controllo per gli array di oggetti
export const isObjectEmpty = (obj: Record<string, unknown>): boolean => {
  // Verifica se l'oggetto è null o undefined
  if (!Boolean(obj)) {
    return true; // Se l'oggetto è null, undefined, è vuoto
  }

  // Itera attraverso le chiavi dell'oggetto
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      // Se il valore è null o undefined, passa alla prossima iterazione
      if (!Boolean(value)) {
        continue;
      }
      // Se il valore è un oggetto e non è vuoto, effettuare controlli
      if (typeof value === 'object' && Boolean(value)) {
        // Se l'oggetto è un Array effettuare controlli
        if (Array.isArray(value)) {
          if ((value as Array<unknown>)?.length === 0) {
            continue;
          } else {
            return false;
          }
        }
        // Se l'oggetto è una data tornare false, necessario per i controlli con YUP che utilizza Date
        if (value instanceof Date && Boolean(value)) {
          return false;
        }
        // Esegue ricorsivamente la funzione isObjectEmpty sull'oggetto annidato
        if (isObjectEmpty(value as Record<string, unknown>)) {
          continue;
        } else {
          return false;
        }
      }
      // Se il valore è una stringa e non è vuota dopo la rimozione degli spazi bianchi, l'oggetto non è vuoto
      if (Boolean(value)) {
        return false;
      }
      // Se un valore non è null, undefined, un oggetto vuoto o una stringa vuota, l'oggetto non è vuoto
      return false;
    }
  }

  // Se nessun valore trovato, l'oggetto è vuoto
  return true;
};
